<template>
    <div class="table-common">
        <a-table
            size="middle"
            :columns="columns"
            :data-source="tableData"
            :pagination="pagination"
            :loading="loading"
            :row-key="(record,index) => record.id+'_'+index"
            bordered
            :locale="{emptyText: '暂无数据'}"
        >
            <template slot="rolePer" slot-scope="text, record">
                <div v-for="item in record.nav" :key="item.menuCode" class="flexStart menu-box">
                    <div class="name-box">{{item.menuName}}</div>：
                    <div v-if="item.subnav" class="name-right-box">
                        <template v-for="sub in item.subnav">
                            <span v-if="sub.isCheck=='1'" class="sub-name-box" :key="sub.menuCode">
                                {{sub.menuName}}
                            </span>
                        </template>
                        <span v-if="(item.subnav&&!item.subnav.length)||!item.subnav" class="sub-name-box">
                            {{item.menuName}}
                        </span>
                    </div>
                </div>
            </template>
            <template slot="latestUpdateTime" slot-scope="text">{{text | dateFormat('YYYY-mm-dd')}}</template>
            <template slot="operation" slot-scope="text, record">
                <a @click="modalShowFun(record)"> 编辑</a>
            </template>
        </a-table>
        <a-modal
        width="70%"
        title="权限修改"
        cancelText="取消"
        okText="确定"
        :visible="modalShow"
        :maskClosable="false"
        @cancel="modalShow=false;"
        @ok="modalOk"
        :confirm-loading="confirmLoading"
        :cancelButtonProps="cancelButtonProps"
        :okButtonProps="cancelButtonProps"
        dialogClass="dialogBig"
        :bodyStyle="{height:'560px',overflow:'auto'}"
        :destroyOnClose="true"
        >
            <character-edit-modal ref="characterModal" :modalData="modalData"></character-edit-modal>
        </a-modal>
    </div>
</template>

<script>
import {getMenuApi} from "@/api/menu.js"
import characterEditModal from "@/pages/system/character/character-edit-modal"
export default {
    name:"characterMain",
    components: {
        characterEditModal
    },
    data() {
        return {
            columns: [
                {
                    title:"角色名称",
                    width:"140px",
                    dataIndex: "roleName"
                },
                {
                    title: "功能权限",
                    dataIndex: "rolePer",
                    scopedSlots: { customRender: "rolePer" }
                },
                {
                    title: "维护日期",
                    dataIndex: "latestUpdateTime",
                    width:"100px",
                    scopedSlots: { customRender: "latestUpdateTime" }
                },
                {
                    title: "操作",
                    dataIndex: "operation",
                    width:"100px",
                    scopedSlots: { customRender: "operation" },
                }
            ],
            tableData: [],
            pagination: {
                pageSize: 10,
                current: 1,
                sortField: "",
                sortOrder: "",
                total: 0,
            },
            loading: false,
            menuData:[],
            modalShow:false,
            modalData:{},
            cancelButtonProps:{
                props:{
                    shape:"round"
                }
            },
            confirmLoading:false
        }
    },
    computed: {},
    methods: {
        getTableData(){
            this.loading = true;
            getMenuApi()
            .then(res => {
                this.loading = false;
                this.tableData = res.data.records;
            })
            .catch(err => {
                this.loading = false;
                console.log(err);
            })
        },
        modalShowFun(data){
            this.modalData = data;
            this.modalShow = true;
        },
        modalOk(){
          let checkFlag = this.$refs.characterModal.check();
          if(!checkFlag){
            return;
          }

          this.confirmLoading = true;
          this.$refs.characterModal.modalOk()
          .then(res => {
              this.$message.success("修改成功");
              this.confirmLoading = false;
              this.getTableData();
              this.modalCancel();
          })
          .catch(err => {
              this.confirmLoading = false;
              this.modalCancel();
              console.log(err);
          })

        },
        modalCancel(){
            this.modalShow = false;
        }
    },
    created() {
        this.getTableData();
    },
    mounted() {},
    activated() {},
    watch: {},
}
</script>
<style scoped>
.menu-box{
    margin-bottom: 15px;
    text-align: left;
    white-space: nowrap;
}
.name-box{
    width: 80px;
    font-weight: bold;
}
.name-right-box{
    flex: 1 0 0;
}
.sub-name-box{
    margin-right: 10px;
}
</style>



// WEBPACK FOOTER //
// src/pages/system/character/character-main.vue